import { initOauthSessionAPI } from './api';

async function initOauthSession () {
    const env = this.env;
    const appStore = this.env.appStore;
    const apiKey = appStore.widgetSettings.apikey;
    const params = {
        icsFilename: appStore.widget.ics_filename,
    };
    const res = await initOauthSessionAPI({
        apiKey,
        body: params,
        widgetId: appStore.widget.id,
        traceId: env.traceId,
        store: this,
    });
    appStore.oauthSessionId = res.data.oauthSessionId;
    // process res..
}

export default initOauthSession;
